import components from "./components";
import confirm from "./confirm";
import orderSubmitConfirm from "./orderSubmitConfirm";
import orderOutOfStock from "./orderOutOfStock";
import orderProductTransfer from "./orderProductTransfer";
import quizProfile from "./quizProfile";
import approvalDelegateEditor from "./approvalDelegateEditor";
import approvalEmployeeOrders from "./approvalEmployeeOrders";
import impersonation from "./impersonation";

export default {
    components,
    confirm,
    orderSubmitConfirm,
    quizProfile,
    orderOutOfStock,
    orderProductTransfer,
    approvalDelegateEditor,
    approvalEmployeeOrders,
    impersonation
}